// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1f9sq","github":"Footer_github__3qbzR"};